import { FieldName } from "../VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";

export const readableFieldName = {
  [FieldName.GrossIncomeToRentRatio]: "Gross income to rent",
  [FieldName.GrossIncome]: "Gross income",
  [FieldName.NetIncome]: "Net income",
  [FieldName.DebtToNetIncome]: "Debt to net income",
  [FieldName.IncomeDocumentFraudCheck]: "Income documents fraud risk detected",

  [FieldName.NoCreditScore]: "No credit score",
  [FieldName.CreditScore]: "Credit score",
  [FieldName.PastDueAccount]: "Past due accounts",
  [FieldName.UnpaidCollectionsBalance]: "Balance past due",
  [FieldName.CollectionsBalance]: "Balance of collections",
  [FieldName.BankruptcyRecords]: "Bankruptcy records",

  [FieldName.HousingCourtRecords]: "Housing court records",

  [FieldName.SexOffenderCheck]: "Sex offender convictions",
  [FieldName.OfacRecords]: "Sanctions (OFAC) convictions",
  [FieldName.FelonyRecords]: "Felony convictions",
  [FieldName.MisdemeanorRecords]: "Misdemeanor convictions",
  [FieldName.OtherCriminalRecords]: "Other criminal convictions",
  [FieldName.AllCriminalRecords]: "All criminal convictions"
} as const;
